import { render, staticRenderFns } from "./credito.vue?vue&type=template&id=716612d2"
import script from "./credito.vue?vue&type=script&lang=js"
export * from "./credito.vue?vue&type=script&lang=js"
import style0 from "./credito.vue?vue&type=style&index=0&id=716612d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports